import { HttpClient, HttpContext, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { finalize, Observable } from 'rxjs';
import { SHOW_MODAL_ON_ERROR } from '../../interceptors/interceptor.token';
import { LIB_CONFIG } from '../../lib.config';
import { Themenfeld } from '../../model/themenfeld';
import { LoaderService } from '../loader.service';
import { BildungsBereich, BildungsbereichService } from '../state/bildungsbereich.service';

@Injectable({
  providedIn: 'root'
})
export class ThemenfelderClient {
  private static readonly PATH = '/pc/v1/themenfeld';
  private readonly httpClient = inject(HttpClient);
  private readonly libConfig = inject(LIB_CONFIG);
  private readonly loaderService = inject(LoaderService);

  public getThemenfelder(bildungsbereich: BildungsBereich): Observable<Themenfeld[]> {
    const isUte = BildungsbereichService.isUte(bildungsbereich);
    this.loaderService.setThemenfelderLoading(true);
    return this.httpClient
      .get<Themenfeld[]>(`${this.libConfig.backendHost}${ThemenfelderClient.PATH}`, {
        params: new HttpParams().set('ute', isUte),
        responseType: 'json',
        context: new HttpContext().set(SHOW_MODAL_ON_ERROR, true)
      })
      .pipe(finalize(() => this.loaderService.setThemenfelderLoading(false)));
  }

  public getThemenfeldSchwerpunkteByObercodenr(obercodenr: string): Observable<Themenfeld[]> {
    this.loaderService.setThemenfeldSchwerpunkteLoading(true);
    return this.httpClient
      .get<Themenfeld[]>(
        `${this.libConfig.backendHost}${ThemenfelderClient.PATH}/${obercodenr}/schwerpunkte`,
        {
          responseType: 'json',
          context: new HttpContext().set(SHOW_MODAL_ON_ERROR, true)
        }
      )
      .pipe(finalize(() => this.loaderService.setThemenfeldSchwerpunkteLoading(false)));
  }

  public getThemenfeldSpezialisierungenByObercodenr(obercodenr: string): Observable<Themenfeld[]> {
    this.loaderService.setThemenfeldSpezialisierungenLoading(true);
    return this.httpClient
      .get<Themenfeld[]>(
        `${this.libConfig.backendHost}${ThemenfelderClient.PATH}/${obercodenr}/spezialisierungen`,
        {
          responseType: 'json',
          context: new HttpContext().set(SHOW_MODAL_ON_ERROR, true)
        }
      )
      .pipe(finalize(() => this.loaderService.setThemenfeldSpezialisierungenLoading(false)));
  }
}
